import { WebAssetOff } from '@mui/icons-material';
import ErrorView from './ErrorView';

function NotFound() {
  return (
    <ErrorView
      title="Not Found"
      heading="Error 404 - Page not found"
      message="Check the address entered. Page may have been moved, renamed, or is temporarily unavailable."
      buttonText="Return to Homepage"
      icon={WebAssetOff}
    />
  );
}

export default NotFound;
